import { useEffect, useState, useRef } from "react";
import axios from "axios";
axios.defaults.withCredentials = true;
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.headers.common["Pragma"] = "no-cache";
axios.defaults.headers.common["Cache-Control"] = "no-store, no-cache, no-transform, must-revalidate, max-age=0";

export const useData = (route) => {
  const [responseData, setResponseData] = useState({});
  const [errors, setErrors] = useState([]);
  const isLoading = useRef(true);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = await axios.get(route);
      setResponseData(response.data);
      isLoading.current = false;
    } catch (e) {
      setErrors(e);
      console.error("error ", e);
    }
  };

  return { responseData, isLoading, errors };
};
